import {DomainEvent} from './DomainEvent';
import type {EntityExportRequest} from './EntityExportRequest';

export interface UserFollowsExportRequest extends EntityExportRequest {
  /** The Firebase IDs of the users to request the export, if not specified, all users are exported */
  readonly users?: string[];
  /** the index of the batch when the transaction is split into multiple batches, defaults to 1 */
  readonly transactionBatchIndex?: number;
  /** number of follows within a batch file, default: 10 */
  readonly batchSize?: number;
}

/**
 * This event can be fired to indicate that a services requires the follows of all or specific users.
 * Another service that is eligible to provide this info will put batches of the requested follows into
 * the specified S3 {@see UserFollowsExportRequest.targetBucket} using
 * the {@see UserFollowsExportRequest.transactionId} as prefix (sub-folder).
 */
export class UserFollowsExportRequested extends DomainEvent<UserFollowsExportRequest> {}
